<script setup lang="ts">
// @ts-expect-error Missing types repository
import VLazyImage from 'v-lazy-image'
</script>

<template>
  <VLazyImage />
</template>

<style scoped>
.v-lazy-image {
  background: black;
}
</style>
